import(/* webpackMode: "eager" */ "/home/ubuntu/download/6955f19666cdef001454bf90/valence_solar_platform/node_modules/next/dist/client/components/app-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6955f19666cdef001454bf90/valence_solar_platform/node_modules/next/dist/client/components/client-page.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6955f19666cdef001454bf90/valence_solar_platform/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6955f19666cdef001454bf90/valence_solar_platform/node_modules/next/dist/client/components/layout-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6955f19666cdef001454bf90/valence_solar_platform/node_modules/next/dist/client/components/not-found-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6955f19666cdef001454bf90/valence_solar_platform/node_modules/next/dist/client/components/render-from-template-context.js");
